import { RootState } from '../store';
import { useSelector, useDispatch } from 'react-redux';
import { setSelectedTimeframe } from '../store/slices/tradingSlice';
import websocketService from '../services/websocket';

import './ChartTimeframe.css'

const ChartTimeframe: React.FC = () => {
  const dispatch = useDispatch();
  const { selectedPair, selectedTimeframe } = useSelector((state: RootState) => state.trading);
  const { isConnected } = useSelector((state: RootState) => state.websocket);

  const handleTimeframeChange = (timeframe: string) => {
    if (timeframe !== selectedTimeframe) {
      dispatch(setSelectedTimeframe(timeframe));

      // Отправляем настройки только при явном изменении таймфрейма пользователем
      if (selectedPair && isConnected) {
        const timeframeMap: Record<string, string> = {
          '10S': '10s',
          '30S': '30s',
          '1M': '1m',
          '5M': '5m',
          '15M': '15m',
          '1H': '1h',
          '4H': '4h',
          '1D': '1d'
        };

        const serverTimeframe = timeframeMap[timeframe] || '1m';


        const ws = (websocketService as any).ws;
        if (ws && ws.readyState === WebSocket.OPEN && (websocketService as any).isAuthenticated) {
          const settingsMessage = {
            t: 15, // Тип сообщения update_settings
            d: {
              pair: selectedPair,
              timeframe: serverTimeframe,
            }
          };

          ws.send(JSON.stringify(settingsMessage));
        }
      }
    }
  };

  return (
    <div className="controls timeframe">
      <button
        className={`button timeframe__button ${selectedTimeframe === '10S' ? 'active' : ''}`}
        onClick={() => handleTimeframeChange('10S')}
      >
        <span className="value">10</span>
        <span className="unit">s</span>
      </button>

      <button
        className={`button timeframe__button ${selectedTimeframe === '30S' ? 'active' : ''}`}
        onClick={() => handleTimeframeChange('30S')}
      >
        <span className="value">30</span>
        <span className="unit">s</span>
      </button>

      <button
        className={`button timeframe__button ${selectedTimeframe === '1M' ? 'active' : ''}`}
        onClick={() => handleTimeframeChange('1M')}
      >
        <span className="value">1</span>
        <span className="unit">m</span>
      </button>

      <button
        className={`button timeframe__button ${selectedTimeframe === '5M' ? 'active' : ''}`}
        onClick={() => handleTimeframeChange('5M')}
      >
        <span className="value">5</span>
        <span className="unit">m</span>
      </button>

      <button
        className={`button timeframe__button ${selectedTimeframe === '15M' ? 'active' : ''}`}
        onClick={() => handleTimeframeChange('15M')}
      >
        <span className="value">15</span>
        <span className="unit">m</span>
      </button>

      <button
        className={`button timeframe__button ${selectedTimeframe === '1H' ? 'active' : ''}`}
        onClick={() => handleTimeframeChange('1H')}
      >
        <span className="value">1</span>
        <span className="unit">h</span>
      </button>

      <button
        className={`button timeframe__button ${selectedTimeframe === '4H' ? 'active' : ''}`}
        onClick={() => handleTimeframeChange('4H')}
      >
        <span className="value">4</span>
        <span className="unit">h</span>
      </button>

      <button
        className={`button timeframe__button ${selectedTimeframe === '1D' ? 'active' : ''}`}
        onClick={() => handleTimeframeChange('1D')}
      >
        <span className="value">1</span>
        <span className="unit">d</span>
      </button>
    </div>
  )
}

export default ChartTimeframe
